;(function($) {

    $(document).ready(function() {

        $(document).on('click', '.renew-link', function(e) {

            e.preventDefault();
            var domain = $(this).data('did');
            
            $.get(Storage.getData('app_url') + 'domain/getRenewLink/' + domain, function (response) {
                if(response.status == 1) {
                    $.fancybox.open({
                        type: 'iframe',
                        padding: 5,
                        content: response.html,
                        afterShow: function () {
                            var form = $('#renew-link');
                            e.preventDefault();
                            form.on('submit', function(e) {
                                e.preventDefault();
                                var submitButton = $(e.originalEvent && e.originalEvent.submitter || document.activeElement);
                                submitButton.button('loading');
                                var userEmail = form.find('#userEmail').val();
                                $.post(Storage.getData('app_url') + 'domain/generateRenewLink/' + domain, {
                                    userEmail: userEmail
                                }, function(response) {
                                    var resSection = $('#renew-link-response');
                                    if(response.status == 1) {
                                      
                                        resSection.
                                            removeClass('hidden').
                                            removeClass('alert-danger alert').
                                            addClass('alert-success alert').
                                            html(response.msg)
                                        ;
                                        submitButton.button('reset');
                                        
                                        // Add click handler for the link after it's added to DOM
                                        resSection.find('a').on('click', function(e) {
                                            e.preventDefault();
                                            
                                            var linkUrl = $(this).attr('href');
                                            var $temp = $('<textarea>');
                                            $('body').append($temp);
                                            $temp.val(linkUrl).select();
                                            document.execCommand('copy');
                                            $temp.remove();
                                            
                                            // Optional: show feedback
                                            var $link = $(this);
                                            var originalText = $link.text();
                                            $link.text('הועתק!');
                                            setTimeout(function() {
                                                $link.text(originalText);
                                            }, 2000);
                                        });
                                    }else{
                                        resSection.
                                            removeClass('hidden').
                                            removeClass('alert-success alert').
                                            addClass('alert-danger alert').
                                            html(response.msg)
                                        ;
                                        submitButton.button('reset');
                                    }

                                });
                                
                            });
                          
                        }
                    })
                }else{
                    $(this).button('reset');
                    console.log(response.status, response.msg);
                }
            });
            
        });
     
    });

  

    
})(jQuery);